// import React, { useEffect, useState } from "react";
// import "./GetStartedPage.css";
// import DoneIcon from "@mui/icons-material/Done";
// import { useDispatch } from "react-redux";
// import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
// import { useNavigate } from "react-router-dom";
// import { getToken, getUserId } from "../../api/index";

// const signUpOptions = [
//   { option: "Google", img: "./GetStarted/googleIcon.svg" },
//   {
//     option: "Apple",
//     img: "./GetStarted/appleIcon.svg",
//   },
//   {
//     option: "Facebook",
//     img: "./GetStarted/facebookIcon.svg",
//   },
//   {
//     option: "X",
//     img: "./GetStarted/twitterIcon.svg",
//   },
// ];

// const GetStartedPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     dispatch(setActiveComponent("enterMobileNumber"));
//     if (getToken() && getUserId()) {
//       navigate("/ballots");
//     }
//   }, []);

//   useEffect(() => {
//     const checkIsMobile = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     checkIsMobile();
//     window.addEventListener("resize", checkIsMobile);

//     return () => {
//       window.removeEventListener("resize", checkIsMobile);
//     };
//   }, []);

//   const handleContinueWithEmailClick = () => {
//     navigate("/signin");
//     dispatch(setActiveComponent("signIn"));
//   };

//   const handleContinueWithPhoneNumberClick = () => {
//     navigate("/signin");
//     dispatch(setActiveComponent("signIn"));
//   };

//   const handleFaceIdClick = () => {
//     navigate("/signin-face-recognition");
//   };

//   const handleSignUpClick = () => {
//     navigate("/SignUpGetStarted");
//     dispatch(setActiveComponent("signUpGetStarted"));
//   };

//   const handleDownloadGoogleAppClick = () => {
//     window.open(
//       "https://play.google.com/store/apps/details?id=com.amalgamate",
//       "_blank"
//     );
//   };

//   const handleDownloadAppleAppClick = () => {
//     window.open(
//       "https://apps.apple.com/in/app/amalgamate/id6744918457",
//       "_blank"
//     );
//   };

//   return (
//     <div className="LandingPage">
//       <div className="landingPageContainer">
//         <div className="landingLeftSection">
//           <div className="landingLeftSectionContainer">
//             <div className="amalgamateLogoContainer">
//               <img
//                 className="webAmalgamateLogo"
//                 src="/Assets/landingPage/AmalgamateLogo.svg"
//                 alt="no img found"
//               />
//             </div>
//             <div className="leftSectionContentContainer">
//               <div className="leftSectionContent">
//                 <DoneIcon
//                   sx={{
//                     height: "20px",
//                     width: "20px",
//                     color: "#48D1CC",
//                     marginTop: "5px",
//                   }}
//                 />
//                 <div className="textContainer">
//                   <span className="contentHeading">Proof of Humanity</span>
//                   <span className="contentTexts">
//                     Only real humans can participate.
//                   </span>
//                   <span className="contentTexts">No bots, no duplicates</span>
//                 </div>
//               </div>
//               <div className="leftSectionContent">
//                 <DoneIcon
//                   sx={{
//                     height: "20px",
//                     width: "20px",
//                     color: "#48D1CC",
//                     marginTop: "5px",
//                   }}
//                 />
//                 <div className="textContainer">
//                   <span className="contentHeading">Full Privacy Control</span>
//                   <span className="contentTexts">Verified Human</span>
//                   <span className="contentTexts">Verified Age</span>
//                   <span className="contentTexts">Verified Voting regions</span>
//                 </div>
//               </div>
//               <div className="leftSectionContent">
//                 <DoneIcon
//                   sx={{
//                     height: "20px",
//                     width: "20px",
//                     color: "#48D1CC",
//                     marginTop: "5px",
//                   }}
//                 />
//                 <div className="textContainer">
//                   <span className="contentHeading">
//                     End the debates, focus on solutions
//                   </span>
//                   <span className="contentTexts">
//                     Advanced content quality voting system to provide users a
//                     more nuanced and transparent way of to evaluate content
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="lowerSection">
//               <div className="webGetTheAppContainer">
//                 <div className="fadingLine1"></div>
//                 <span className="webGetTheAppText">Get The App</span>
//                 <div className="fadingLine2"></div>
//               </div>
//               <div className="downloadAppCards">
//                 <div className="downloadAppCardContainer">
//                   <div
//                     className="webDownloadAppCard"
//                     onClick={handleDownloadGoogleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/playstoreIcon.svg"
//                       alt="no img found"
//                       className="webDownloadAppCardIcon"
//                     />
//                     <div className="downloadAppCardTextContainer">
//                       <span className="webDownloadAppCardText1">Get it on</span>
//                       <span className="webDownloadAppCardText2">
//                         Google Play
//                       </span>
//                     </div>
//                   </div>
//                   <div
//                     className="webDownloadAppCard"
//                     onClick={handleDownloadAppleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/appStoreIcon.svg"
//                       alt="no img found"
//                       className="webDownloadAppCardIcon2"
//                     />
//                     <div className="downloadAppCardTextContainer">
//                       <span className="webDownloadAppCardText1">Get it on</span>
//                       <span className="webDownloadAppCardText2">App Store</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="landingRightSection">
//           {/* Mobile Logo at top */}
//           {isMobile && (
//             <div className="mobileLogoContainer">
//               <img
//                 className="mobileAmalgamateLogo"
//                 src="/Assets/landingPage/AmalgamateLogo.svg"
//                 alt="no img found"
//               />
//             </div>
//           )}

//           <div className="landingRightSectionContainer">
//             <div className="GetStarted">
//               <span className="getStartedText">Let's Get Started</span>
//               <button
//                 className="btnContainer"
//                 onClick={handleContinueWithEmailClick}
//               >
//                 <span className="btnText">Continue with Email</span>
//               </button>
//               <div className="dividerContainer">
//                 <div className="divider"></div>
//                 <span className="orText">OR</span>
//                 <div className="divider"></div>
//               </div>
//               <button
//                 className="btnContainer btnContainerDuplicate"
//                 onClick={handleContinueWithEmailClick}
//               >
//                 <span className="btnText">Continue with Google</span>
//               </button>



//               <button
//                 className="btnContainer btnContainerDuplicate"
//                 onClick={handleContinueWithEmailClick}
//               >
//                 <span className="btnText">Continue with Facebook</span>
//               </button>
//               <button
//                 className="btnContainer btnContainerDuplicate"
//                 onClick={handleContinueWithPhoneNumberClick}
//               >
//                 <span className="btnText">Continue with Phone Number</span>
//               </button>

//               <div className="dividerContainer">
//                 <div className="divider"></div>
//                 <span className="orText">OR</span>
//                 <div className="divider"></div>
//               </div>

//               <div className="faceIdContainer" onClick={handleFaceIdClick}>
//                 <img
//                   src="/Assets/GetStarted/faceIdIcon.svg"
//                   alt="no img found"
//                   className="faceIdIcon"
//                 />
//                 <span className="faceIdText">Face Unlock</span>
//               </div>
//               <div className="signUpContainer">
//                 <span className="signUpText1">Don't have an account? </span>
//                 <span className="signUpText2" onClick={handleSignUpClick}>
//                   Sign Up
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Mobile Download Cards at bottom */}
//           {isMobile && (
//             <div className="mobileDownloadSection">
//               <div className="mobileGetTheAppContainer">
//                 <div className="mobileFadingLine1"></div>
//                 <span className="mobileGetTheAppText">Get The App</span>
//                 <div className="mobileFadingLine2"></div>
//               </div>
//               <div className="mobileDownloadAppCards">
//                 <div className="mobileDownloadAppCardContainer">
//                   <div
//                     className="mobileDownloadAppCard"
//                     onClick={handleDownloadGoogleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/playstoreIcon.svg"
//                       alt="no img found"
//                       className="mobileDownloadAppCardIcon"
//                     />
//                     <div className="mobileDownloadAppCardTextContainer">
//                       <span className="mobileDownloadAppCardText1">
//                         Get it on
//                       </span>
//                       <span className="mobileDownloadAppCardText2">
//                         Google Play
//                       </span>
//                     </div>
//                   </div>
//                   <div
//                     className="mobileDownloadAppCard"
//                     onClick={handleDownloadAppleAppClick}
//                   >
//                     <img
//                       src="/Assets/LandingPage/appStoreIcon.svg"
//                       alt="no img found"
//                       className="mobileDownloadAppCardIcon2"
//                     />
//                     <div className="mobileDownloadAppCardTextContainer">
//                       <span className="mobileDownloadAppCardText1">
//                         Get it on
//                       </span>
//                       <span className="mobileDownloadAppCardText2">
//                         App Store
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default GetStartedPage;



/*---------------------------Final correct code------------------------------ */


import React, { useEffect, useState } from "react";
import "./GetStartedPage.css";
import AuthLeftSection from "../../Components/Shared/AuthLeftSection/AuthLeftSection";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent } from "../../Redux/Slices/activeComponentSlice";
import { useNavigate } from "react-router-dom";
import { getToken, getUserId, setAuthTokens } from "../../api/index";
import { GoogleLogin } from "@react-oauth/google";
import { googleLoginSignup } from "../../api/auth";
import {jwtDecode} from "jwt-decode";
import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
import { Snackbar, Alert } from '@mui/material';
import { getRedirectPath, storeRedirectPath, clearRedirectPath } from "../../utils/authRedirect";

const GetStartedPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const flags = useSelector((state) => state.featureFlags?.flags) || {
    isGoogleEnable: true,
    isMetaEnable: false,
    isAppleEnable: false,
    isFaceEnabled: false,
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  useEffect(() => {
    storeRedirectPath();
    dispatch(setActiveComponent("getStarted"));
    if (getToken() && getUserId()) {
      const target = getRedirectPath();
      clearRedirectPath();
      navigate(target, { replace: true });
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const handleContinueWithEmailClick = () => {
    navigate("/signin" + window.location.search);
    dispatch(setActiveComponent("signIn"));
  };

  const handleContinueWithPhoneNumberClick = () => {
    
    dispatch(setActiveComponent("signInEnterMobileNumber"));
    navigate("/signin" + window.location.search);
  };

  const handleFaceIdClick = () => navigate("/signin-face-recognition" + window.location.search);
  const handleSignUpClick = () => {
    navigate("/SignUpGetStarted" + window.location.search);
    dispatch(setActiveComponent("signUpGetStarted"));
  };

  const handleDownloadGoogleAppClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.amalgamate",
      "_blank"
    );
  };

  const handleDownloadAppleAppClick = () => {
    window.open(
      "https://apps.apple.com/in/app/amalgamate/id6744918457",
      "_blank"
    );
  };

  // ✅ Google Login Handlers
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse.credential;
      const decoded = jwtDecode(idToken);
      console.log("Google user info:", decoded);

      const response = await googleLoginSignup(idToken, "");
      console.log("Backend Response:", response);

      if (response?.data?.userDetails?.userId) {
        localStorage.setItem("userId", response.data.userDetails.userId);
      }

      setAuthTokens(response.data);
      dispatch(setUserDetails(response.data.userDetails));

      const target = getRedirectPath();
      clearRedirectPath();
      navigate(target);
    } catch (error) {
      console.error("Google login failed:", error);
      showSnackbar("Google login failed!", 'error');
    }
  };

  const handleGoogleError = (error) => {
    console.error("Google login error:", error);
    
  };

  return (
    <div className="LandingPage">
      <div className="landingPageContainer">
        {/* Left Section */}
        <AuthLeftSection />

        {/* Right Section */}
        <div className="landingRightSection">
          {isMobile && (
            <div 
              className="mobileLogoContainer" 
              onClick={() => navigate('/')} 
              style={{ cursor: 'pointer' }}
              title="Return to Amalgamate Home"
            >
              <img className="mobileAmalgamateLogo" src="/Assets/LandingPage/AmalgamateLogo.svg" alt="Amalgamate Logo" />
            </div>
          )}

          <div className="landingRightSectionContainer">
            <div className="GetStarted">
              <span className="getStartedText">Let's Get Started</span>
              <button className="btnContainer" onClick={handleContinueWithEmailClick}>
                <span className="btnText">Continue with Email</span>
              </button>

              <div className="dividerContainer">
                <div className="divider"></div>
                <span className="orText">OR</span>
                <div className="divider"></div>
              </div>

              {/* Conditional third-party buttons (aligned like SignUpGetStarted) */}
              {flags.isGoogleEnable && (
                <div className="btnContainer btnContainerDuplicate" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
                  <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} useOneTap={false} />
                </div>
              )}

              {flags.isMetaEnable && (
                <button className="btnContainer btnContainerDuplicate" onClick={handleContinueWithEmailClick}>
                  <span className="btnText">Continue with Facebook</span>
                </button>
              )}

              <button className="btnContainer btnContainerDuplicate" onClick={handleContinueWithPhoneNumberClick}>
                <span className="btnText">Continue with Phone Number</span>
              </button>

              {flags.isFaceEnabled && (
                <>
                  <div className="dividerContainer">
                    <div className="divider"></div>
                    <span className="orText">OR</span>
                    <div className="divider"></div>
                  </div>

                  <div className="faceIdContainer" onClick={handleFaceIdClick}>
                    <img src="/Assets/GetStarted/FaceIdIcon.svg" alt="no img found" className="faceIdIcon" />
                    <span className="faceIdText">Face Unlock</span>
                  </div>
                </>
              )}

              <div className="signUpContainer">
                <span className="signUpText1">Don't have an account? </span>
                <span className="signUpText2" onClick={handleSignUpClick}>Sign Up</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default GetStartedPage;
